/**
 * 0.37.62 — Backward-compat redirect for the pre-language-prefix
 * public URL pattern. External links out in the wild pointing at
 * `caf.govtech.am/p/foo` should keep working — this component
 * takes such a hit and rewrites it to `caf.govtech.am/<lang>/p/foo`
 * where `<lang>` is the visitor's currently-effective language
 * (from localStorage / server preference / default).
 *
 * `replace` on <Navigate> so the language-less URL doesn't sit in
 * the visitor's history. A back button click from the redirected
 * page returns to whatever site brought them here, not to the
 * bare `/p/foo` which would immediately re-redirect.
 */
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function RedirectToLangStaticPage() {
  const { slug } = useParams();
  const { language } = useLanguage();
  const location = useLocation();
  /* 0.42.72 - Keep the prefix that was asked for. This added /p/ to
     everything, which was harmless while both prefixes answered and is
     a 404 now that only the page's own one does. A bare /<slug> with no
     prefix still goes to /p/: nothing here knows the page's setting,
     and StaticPage sends it on if it is wrong. */
  const asked = location.pathname.split('/')[1];
  const prefix = asked === 'services' ? 'services' : 'p';
  /* 0.49.57 - With the address's values, its #part and the mark of
     values handed over through the server (lib/valueHandover.js): a
     link written without the language (/p/apply?training=t15) lost
     them on the way to /hy/p/apply. */
  return <Navigate to={`/${language}/${prefix}/${slug}${location.search}${location.hash}`}
                   state={location.state} replace />;
}
